import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { Map, MapPin, Landmark, Network, UserRound, Truck, Search, ChevronLeft, ChevronRight } from 'lucide-react'
import s from './PanelBase.module.scss'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'
import ReadOnlyOperatorsList from './ReadOnlyOperatorsList'
import ReadOnlyDriversList from './ReadOnlyDriversList'
import ReadOnlyBranchesList from './ReadOnlyBranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const PrivatePointsPanel = ({
  privatePointsFilter,
  setPrivatePointsFilter,
  filteredPrivatePoints,
  privatePointsPagination,
  loadPrivatePointsPage,
  expandedPrivatePoint,
  setExpandedPrivatePoint,
  expandedOperatorsPrivatePoint,
  setExpandedOperatorsPrivatePoint,
  expandedDriversPrivatePoint,
  setExpandedDriversPrivatePoint,
  expandedBranchesPrivatePoint,
  setExpandedBranchesPrivatePoint,
  loadOperatorsByPrivatePointPage,
  loadDriversByPrivatePointPage,
  loadBranchesByPrivatePointPage,
  operatorsByPrivatePoint,
  driversByPrivatePoint,
  branchesByPrivatePoint,
  operatorsPaginationByPrivatePoint,
  driversPaginationByPrivatePoint,
  branchesPaginationByPrivatePoint,
  operatorsFilterByPrivatePoint,
  driversFilterByPrivatePoint,
  branchesFilterByPrivatePoint,
  setOperatorsFilterByPrivatePoint,
  setDriversFilterByPrivatePoint,
  setBranchesFilterByPrivatePoint,

  expandedDriverByPrivatePoint,
  toggleDriver,
  privatePoints
}) => {
  useInterfaceLanguage();
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <SectionHeading icon={Landmark} title={tr("Соц. Объекты и МСУ")} />
        {tr(privatePointsPagination?.count > 0 && (
          <span className={s.totalBadge}>{tr("Всего: ")}{tr(privatePointsPagination.count)}</span>
        ))}
      </div>

      <div className={s.searchRow}>
        <Search size={16} aria-hidden="true" />
        <input className={s.searchInput} placeholder={tr("Поиск по объекту...")} value={privatePointsFilter} onChange={(e) => setPrivatePointsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadPrivatePointsPage(1, privatePointsFilter) }} />
      </div>

      {filteredPrivatePoints && filteredPrivatePoints.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Название")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Местоположение")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredPrivatePoints.map((pp, index) => (
                <React.Fragment key={pp.id}>
                  <tr>
                    <td data-label={tr("№")} className={s.numCell}>{tr(index + 1)}</td>
                    <td data-label={tr("Название")} className={s.nameCell} onClick={() => { const newVal = (expandedPrivatePoint === pp.id ? null : pp.id); setExpandedPrivatePoint(newVal); if (newVal) loadOperatorsByPrivatePointPage(pp.id, 1); }}>{tr(pp.name)}</td>
                    <td data-label={tr("Телефон")}>{tr(pp.phone || '—')}</td>
                    <td data-label={tr("Местоположение")}>
                      {pp.geo ? (
                        <div style={{ display: 'flex', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${pp.geo}`, '_blank')} className={s.geoBtn}><Map size={14} aria-hidden="true" />{tr(" Карты")}</button>
                            <button onClick={() => { const el = document.getElementById(`pp-map-${pp.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none'; }} className={s.mapToggleBtn} aria-label={tr("Показать или скрыть мини-карту")}><MapPin size={15} aria-hidden="true" /></button>
                          </div>
                          <div id={`pp-map-${pp.id}`} style={{ width: 200, height: 150, display: 'none' }}><MiniMap geo={pp.geo} /></div>
                        </div>
                      ) : '—'}
                    </td>
                    <td data-label={tr("Действия")}>
                      <button className={`${s.actionBtn}${expandedBranchesPrivatePoint === pp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedBranchesPrivatePoint === pp.id ? null : pp.id; setExpandedBranchesPrivatePoint(v); if (v) loadBranchesByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}><Network size={14} aria-hidden="true" />{tr("Филиалы")}</button>
                      <button className={`${s.actionBtn}${expandedOperatorsPrivatePoint === pp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedOperatorsPrivatePoint === pp.id ? null : pp.id; setExpandedOperatorsPrivatePoint(v); if (v) loadOperatorsByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}><UserRound size={14} aria-hidden="true" />{tr("Операторы")}</button>
                      <button className={`${s.actionBtn}${expandedDriversPrivatePoint === pp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedDriversPrivatePoint === pp.id ? null : pp.id; setExpandedDriversPrivatePoint(v); if (v) loadDriversByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}><Truck size={14} aria-hidden="true" />{tr("Водители")}</button>
                    </td>
                  </tr>
                  {tr(expandedPrivatePoint === pp.id && (
                    <tr className={s.subRow}>
                      <td colSpan={5}>
                        <div className={s.subContent}>
                          {tr(expandedOperatorsPrivatePoint === pp.id && (
                            <ReadOnlyOperatorsList
                              base={pp}
                              operators={operatorsByPrivatePoint[pp.id]}
                              operatorsFilter={operatorsFilterByPrivatePoint[pp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadOperatorsPage={loadOperatorsByPrivatePointPage}
                              operatorsPagination={operatorsPaginationByPrivatePoint[pp.id]}
                              title={tr("Операторы этого соц.объекта или МСУ")}
                            />
                          ))}

                          {tr(expandedDriversPrivatePoint === pp.id && (
                            <ReadOnlyDriversList
                              base={pp}
                              drivers={driversByPrivatePoint[pp.id]}
                              driversFilter={driversFilterByPrivatePoint[pp.id]}
                              setDriversFilter={(v) => setDriversFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadDriversPage={loadDriversByPrivatePointPage}
                              driversPagination={driversPaginationByPrivatePoint[pp.id]}
                              expandedDriver={expandedDriverByPrivatePoint}
                              toggleDriver={toggleDriver}
                              title={tr("Водители этого соц.объекта или МСУ")}
                            />
                          ))}

                          {tr(expandedBranchesPrivatePoint === pp.id && (
                            <ReadOnlyBranchesList
                              base={pp}
                              baseType="соц.объекта или МСУ"
                              branches={branchesByPrivatePoint[pp.id]}
                              branchesFilter={branchesFilterByPrivatePoint[pp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadBranchesPage={loadBranchesByPrivatePointPage}
                              branchesPagination={branchesPaginationByPrivatePoint[pp.id]}
                            />
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <EmptyState icon={Landmark} title={tr("Список пуст")} description={tr("Измените поиск или проверьте записи в этом разделе.")} compact />
      )}

      {tr(!privatePointsFilter && privatePointsPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!privatePointsPagination.previous} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) - 1)}><ChevronLeft size={15} aria-hidden="true" />{tr("Пред.")}</button>
          <span>{tr("Стр. ")}{tr(privatePointsPagination.page || 1)}{tr(" из ")}{Math.ceil(privatePointsPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!privatePointsPagination.next} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) + 1)}>{tr("След.")}<ChevronRight size={15} aria-hidden="true" /></button>
        </div>
      ))}
    </div>
  )
}

export default PrivatePointsPanel
